export default __webpack_public_path__ + "static/media/Prarie-Gayfeather_L1.e9c0a25a.png";